import type { ClassValue } from "clsx"
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import type { Updater } from "@tanstack/vue-table";
import type { Ref } from "vue";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const currencyFormatter = new Intl.NumberFormat("pl-PL", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});


export function dateFormatter(date: Date): string;
export function dateFormatter(date: string): string;
export function dateFormatter(date: Date | string): string {
  if (!date) return "";
  const iso = typeof date === "string" ? date : date.toString();
  return new Intl.DateTimeFormat("pl-PL", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(iso));
}

export function dateTimeFormatter(date: Date): string;
export function dateTimeFormatter(date: string): string;
export function dateTimeFormatter(date: Date | string): string {
  if (!date) return "";
  const iso = typeof date === "string" ? date : date.toString();
  return new Intl.DateTimeFormat("pl-PL", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(iso));
}

export function dateOnly(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString();
}

export function valueUpdater<T extends Updater<any>>(
  updaterOrValue: T,
  ref: Ref
) {
  ref.value =
    typeof updaterOrValue === "function"
      ? updaterOrValue(ref.value)
      : updaterOrValue;
}

export function timeOnly(value: string | Date | null | undefined): string {
  if (!value) return "";

  const date =
    typeof value === "string" ? new Date(`1970-01-01T${value}`) : value;

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${hours}:${minutes}`;
}
